"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _email = require("@/api/email");
var _request = _interopRequireDefault(require("@/utils/request"));
var _leads = require("@/api/leads");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.listLoading = false;
    this.savingAccount = false;
    this.selectedAccountId = null;
    // pagination
    this.page = 1;
    this.limit = 20;
    this.total = 0;
    // search
    this.search = '';
    // dialogs
    this.accountDialog = false;
    this.syncDialog = false;
    // mark as read
    this.markingReadId = null;
    // account form
    this.accountForm = {
      email: '',
      isActive: true
    };
    // sync dialog state
    this.emailAccounts = [];
    this.loadingAccounts = false;
    this.syncingAccountId = null;
    this.syncingAll = false;
  }
  created() {
    this.getList();
    this.loadAccounts(); // 🔥 important
  }
  // ── List ──────────────────────────────────────────────────────
  async getList() {
    this.listLoading = true;
    try {
      const res = await (0, _email.getEmails)({
        page: this.page,
        limit: this.limit,
        search: this.search || undefined,
        accountId: this.selectedAccountId || undefined // ✅ add this
      });
      this.list = res.data || res.data.data;
      this.total = res.total;
    } catch (e) {
      this.$message.error('Failed to load emails');
    } finally {
      this.listLoading = false;
    }
  }
  async getListByAccount(accountId) {
    this.listLoading = true;
    try {
      const res = await (0, _email.getEmails)({
        page: 1,
        limit: this.limit,
        accountId
      });
      this.list = res.data;
      this.total = res.total;
      this.page = 1;
    } catch (e) {
      this.$message.error('Failed to load emails');
    } finally {
      this.listLoading = false;
    }
  }
  handlePageChange(page) {
    this.page = page;
    this.getList();
  }
  handleAccountChange() {
    this.page = 1;
    this.getList();
  }
  handleSizeChange(size) {
    this.limit = size;
    this.page = 1;
    this.getList();
  }
  handleRowClick(row) {
    this.$router.push('/email/view/' + row.id);
  }
  // ── Mark as Read ──────────────────────────────────────────────
  async handleMarkAsRead(row) {
    this.markingReadId = row.id;
    try {
      await (0, _email.markAsRead)(row.id);
      row.isRead = true;
      this.$message.success('Marked as read');
    } catch (e) {
      var _err$response, _err$response2;
      const err = e;
      const msg = (err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.message) || 'Failed to mark as read';
      this.$message.error(msg);
      console.error('markAsRead error:', (err === null || err === void 0 || (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) || err);
    } finally {
      this.markingReadId = null;
    }
  }
  // ── Add to Lead ───────────────────────────────────────────────
  extractEmail(raw) {
    if (!raw) return '';
    const match = raw.match(/<(.+?)>/);
    if (match) return match[1];
    return raw.split(',')[0].trim();
  }
  async handleAddToLead(row) {
    console.log('CLICKED ADD TO LEAD', row);
    try {
      const email = this.extractEmail(row.from); // ✅ ONLY TO
      if (!email) {
        this.$message.error('No recipient email found');
        return;
      }
      const res = await (0, _leads.resolveFromEmail)(email);
      const {
        action,
        data
      } = res;
      // 🟢 CASE 1 → CLIENT
      if (action === 'CREATE_CLIENT') {
        this.$router.push({
          path: '/clients/add',
          query: {
            email: data.email,
            name: data.companyName,
            ...(data.companyId ? {
              companyId: String(data.companyId)
            } : {}),
            from: 'addToLead',
            step: 'client'
          }
        });
        return;
      }
      // 🟡 CASE 2 → CONTACT
      // 🟡 CASE 2 → CONTACT
      if (action === 'CREATE_CONTACT') {
        this.$router.push({
          path: '/clients-contacts/add',
          query: {
            email: data.email,
            clientId: String(data.clientId),
            from: 'addToLead',
            step: 'contact'
          }
        });
        return;
      }
      // 🔵 CASE 3 → LEAD
      if (action === 'CREATE_LEAD') {
        var _fullEmail$body, _fullEmail$data;
        const fullEmail = await (0, _email.getEmailById)(row.id);
        const rawBody = ((_fullEmail$body = fullEmail === null || fullEmail === void 0 ? void 0 : fullEmail.body) !== null && _fullEmail$body !== void 0 ? _fullEmail$body : fullEmail === null || fullEmail === void 0 || (_fullEmail$data = fullEmail.data) === null || _fullEmail$data === void 0 ? void 0 : _fullEmail$data.body) || '';
        const plainBody = rawBody ? rawBody.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : '';
        this.$router.push({
          path: '/leads/add',
          query: {
            clientId: String(data.clientId),
            contactId: String(data.contactId),
            email: data.email,
            emailId: String(row.id),
            subject: row.subject,
            emailBody: plainBody,
            source: 'email',
            accountEmail: row.accountEmail // 👈 from inbox account
          }
        });
        return;
      }
    } catch (e) {
      this.$message.error('Failed to process lead');
    }
  }
  // ── Sync Accounts ─────────────────────────────────────────────
  openSyncDialog() {
    this.syncDialog = true;
  }
  async loadAccounts() {
    this.loadingAccounts = true;
    try {
      const res = await (0, _request.default)({
        url: '/email/accounts/active',
        method: 'get'
      });
      this.emailAccounts = res.data || res;
    } catch (e) {
      this.$message.error('Failed to load accounts');
    } finally {
      this.loadingAccounts = false;
    }
  }
  async syncSingleAccount(account) {
    this.syncingAccountId = account.id;
    try {
      await (0, _request.default)({
        url: `/email/accounts/${account.id}/sync`,
        method: 'post'
      });
      account.lastSyncedAt = new Date().toISOString();
      this.$message.success(`"${account.email}" synced successfully`);
      await this.getListByAccount(account.id);
      this.syncDialog = false;
    } catch (e) {
      this.$message.error(`Failed to sync "${account.email}"`);
    } finally {
      this.syncingAccountId = null;
    }
  }
  async syncAllAccounts() {
    this.syncingAll = true;
    try {
      await (0, _email.syncInbox)();
      const now = new Date().toISOString();
      this.emailAccounts.forEach(a => {
        if (a.isActive) a.lastSyncedAt = now;
      });
      this.$message.success('All active accounts synced');
      await this.getList();
      this.syncDialog = false;
    } catch (e) {
      this.$message.error('Sync all failed');
    } finally {
      this.syncingAll = false;
    }
  }
  // ── Account Dialog ────────────────────────────────────────────
  async connectGmail() {
    const res = await (0, _email.getGoogleLoginUrl)();
    window.open(res.url, '_blank');
  }
  openAccountDialog() {
    this.accountForm = {
      email: '',
      isActive: true
    };
    this.accountDialog = true;
  }
  async saveAccount() {
    this.savingAccount = true;
    try {
      await (0, _request.default)({
        url: '/email/accounts/save',
        method: 'post',
        data: this.accountForm
      });
      this.$notify({
        title: 'Success',
        message: 'Email Account Added',
        type: 'success'
      });
      this.accountDialog = false;
      this.getList();
    } catch (e) {
      this.$message.error('Failed to save account');
    } finally {
      this.savingAccount = false;
    }
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'EmailList'
})], default_1);
var _default = exports.default = default_1;